export default "__VITE_ASSET__dkkj89tD__"